import Vue from "vue"
import networkOffline from "./network-offline.vue"
const NetworkOffline = Vue.extend(networkOffline)

const el = new NetworkOffline().$mount().$el

export const online = () => {
  if (el.parentNode === document.body) {
    document.body.removeChild(el)
  }
}

export const offline = () => {
  if (el.parentNode !== document.body) {
    document.body.appendChild(el)
  }
}

export const bootstrap = () => {
  if (navigator.onLine) {
    online()
  } else {
    offline()
  }

  window.addEventListener("offline", e => {
    offline()
  })

  window.addEventListener("online", e => {
    online()
  })
}
